import { IkeOfficeBootstrap } from './bootstrap';
import type { BoundWindow } from './services/window.service';
import { BrowserCheck } from './util/browser-check';

/**
 * This functions gets imported by office-server and run there
 */
export default function () {
	// Window.location.origin is sometimes undefined in IE
	// see https://connect.microsoft.com/IE/feedback/details/1763802/location-origin-is-undefined-in-ie-11-on-windows-10-but-works-on-windows-7

	if (!window.location.origin) {
		(window.location as any).origin =
			window.location.protocol +
			'//' +
			window.location.hostname +
			(window.location.port ? ':' + window.location.port : '');
	}

	IkeOfficeBootstrap.init(window as unknown as BoundWindow);

	// Check Browser and OS compatibility
	const browserCheck = new BrowserCheck();
	// eslint-disable-next-line @typescript-eslint/no-floating-promises
	browserCheck.validateBrowser();
}
